import React, { useCallback } from 'react';
import Collapse from '@mui/material/Collapse';
import styles from './Collapsible.module.scss';

export default function Collapsible({ collapsed = true, children }) {
  const handleEntered = useCallback(node => {
    const firstInput = node.querySelector(
      'input:not([type="hidden"]):not([disabled]), textarea:not([disabled]), select:not([disabled])',
    );

    if (firstInput) {
      firstInput.focus();
      return;
    }

    const firstFocusable = node.querySelector(
      'button:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])',
    );

    if (firstFocusable) {
      firstFocusable.focus();
    }
  }, []);

  return (
    <div className={styles.container}>
      <Collapse
        in={!collapsed}
        timeout={500}
        unmountOnExit
        className={styles.childrenContainer}
        onEntered={handleEntered}
      >
        {children}
      </Collapse>
    </div>
  );
}
